import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { toaster } from '../../helpers/toaster';
import { TextInput } from 'carbon-components-react';

import { resetPasswordAPI } from '../../api/resetPassword';
import Button from '../../components/Button/Button';
import { Container, InputContainer, TextInputContainer, PrimaryText, SecondaryText } from './Login';

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const { client } = useParams();

  const onSubmit = () => {
    setIsProcessing(true);
    resetPasswordAPI(email).then(_ => {
      toaster("Password reset link was sent to your email", "success")
    }).catch(error => {
      if (!error.response) {
        // network error
      toaster("Something went wrong, please try again later", "error")
      } else {
        toaster("Password reset link was sent to your email", "success")
      }
    }).finally(() => {
      setIsProcessing(false);
    })
  }

  const onKeyEnter = (e) => {
    if(e.keyCode === 13) {
      onSubmit()
    }
  }

  return (
    <Container>
      <InputContainer>
        <PrimaryText>Reset Password</PrimaryText>
        <SecondaryText>Enter your email address</SecondaryText>
        <TextInputContainer
          onKeyDown={onKeyEnter}
          style={{marginTop: '10px', display: 'flex', justifyContent: 'center', 'alignItems': 'center'}}
        >
          <TextInput
            id="login-email"
            labelText=""
            placeholder='example@mail.com'
            onChange={e => setEmail(e.target.value)}
            style={{display: 'flex', justifyContent: 'center', 'alignItems': 'center'}}
          />
        </TextInputContainer>
        <Button
          style={{ width: "100%", marginTop:10 }}
          onClick={onSubmit} disabled={isProcessing}>
          Reset Password
        </Button>
        <Link to={`/${client}`} style={{ marginTop: 10 }}>Back to Login</Link>
      </InputContainer>
    </Container>
  )
}

export default ResetPassword;
